import React, { useEffect } from "react";
import { Card, Button, Table, Layout, Radio } from "antd";
import { fmtDate2, fmtDateTime } from "../../common/Utils";
import { UserLink } from "../../components/UserLink/UserLink";
import { IdCheckDlg } from "./IdCheckDlg";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import moment from "moment";
import { Toolbar } from "../../components/Toolbar";
import { useHistory, useLocation } from "react-router";

export const IdCheck2Page = observer(() => {
  const { idCheck } = Store;
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    idCheck.onLocation(location);
  }, []);

  useEffect(() => {
    idCheck.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    idCheck.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    idCheck.sortedInfo = sorter;
    // idCheck.refresh();
  };

  const onTab = (status) => {
    const query = new URLSearchParams({ status });
    history.push({
      search: query.toString(),
    });
  };

  const onDetail = (item) => {
    idCheck.isReject = false;
    idCheck.selected = item;
  };

  const onCloseDetail = (refresh) => {
    idCheck.selected = null;
    if (refresh) {
      idCheck.refresh();
    }
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "User",
      key: "userid",
      render: (_, r) => <UserLink userId={r.userId} name={r.user.name} />,
      sorter: (a, b) => a.user.name.toLocaleLowerCase().localeCompare(b.user.name.toLocaleLowerCase()),
    },
    {
      title: "Request Time",
      dataIndex: "createDate",
      key: "createDate",
      defaultSortOrder: "descend" as const,
      render: (v) => fmtDateTime(v),
      sorter: (a, b) => moment(a.createDate).valueOf() - moment(b.createDate).valueOf(),
    },
    {
      title: "ID Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "First Time?",
      dataIndex: "firstTime",
      render: (v) => (v ? "Yes" : "No"),
    },

    ...(idCheck.filter.status === "Verified"
      ? [
          {
            title: "ID expiration Date",
            dataIndex: "expirationDate",
            render: (v) => fmtDate2(v),
          },
        ]
      : []),

    ...(idCheck.filter.status === "Rejected"
      ? [
          {
            title: "Reason",
            dataIndex: "reason",
            width:"25%"
          },
        ]
      : []),

    ...(idCheck.filter.status !== "Pending"
      ? [
          {
            title: "Review Date",
            dataIndex: "reviewDate",
            render: (v) => fmtDate2(v),
          },
        ]
      : []),
    {
      title: "",
      key: "opt",
      render: (_, r) => (
        <Button type="link" onClick={() => onDetail(r)}>
          Details
        </Button>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar>
        <Radio.Group size="large" value={idCheck.filter.status} onChange={(e) => onTab(e.target.value)}>
          <Radio.Button value="Pending">Pending</Radio.Button>
          <Radio.Button value="Rejected">Rejected</Radio.Button>
          <Radio.Button value="Verified">Verified</Radio.Button>
        </Radio.Group>
      </Toolbar>
      <Card
        style={{ marginTop: 12 }}
        size="small"
        bodyStyle={{ padding: 0 }}
        extra={
          <Button loading={idCheck.loading} size="small" style={{ float: "right" }} onClick={() => idCheck.refresh()}>
            Refresh
          </Button>
        }
      >
        <Table
          size="small"
          onChange={onChange}
          pagination={{ ...idCheck.pagination, onChange: onPage }}
          loading={idCheck.loading}
          rowKey="id"
          columns={columns}
          dataSource={idCheck.data.items}
        />
        {idCheck.selected && <IdCheckDlg onClose={onCloseDetail}></IdCheckDlg>}
      </Card>
    </Layout.Content>
  );
});

